/**
 * @generated SignedSource<<929895f2c8334926debdfac948ec145e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type blockquoteLongReadContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"contentShareWidgetContent">;
  readonly " $fragmentType": "blockquoteLongReadContent";
};
export type blockquoteLongReadContent$key = {
  readonly " $data"?: blockquoteLongReadContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"blockquoteLongReadContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "blockquoteLongReadContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentShareWidgetContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "4e62d355b59b96add4ef083c36fd2912";

export default node;
